import React from "react";
import styles from "./swipeable-card.module.css";
import { SwipeableHandlers } from "react-swipeable"; // rename styles for generic use

type SwipeDirection = "left" | "right" | "";

type SwipeableCardProps = {
  content: React.ReactNode;
  actions: React.ReactNode;
  handlers: SwipeableHandlers;
  swipeDirection: SwipeDirection;
};

export function SwipeableCard({
  content,
  actions,
  handlers,
  swipeDirection,
}: SwipeableCardProps) {
  return (
    <div className={styles["swipeable-card"]} {...handlers}>
      <div
        className={
          swipeDirection === "left"
            ? styles["swipe-left"]
            : swipeDirection === "right"
              ? styles["swipe-right"]
              : styles["swipe-none"]
        }
      >
        {content}
      </div>

      {/* render action buttons */}
      {actions}
    </div>
  );
}
